var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ud-Visit_Gram",class:{
    'ud-Visit_Gram_Omo': _vm.isOmo,
    'ud-Visit_Gram_CompanyActivity': _vm.isCompany
  },attrs:{"id":_vm.gramId}},[_c('div',{staticClass:"ud-Visit_GramIcon"},[_c('div',{class:_vm.iconClass},[_c('Icon',{attrs:{"icon":_vm.iconDocument,"size":18,"color":_vm.iconColor}})],1)]),_c('div',{staticClass:"ud-Visit_GramBody"},[_c('div',{staticClass:"ud-Visit_GramTime"},[_vm._v(_vm._s(_vm.time))]),_c('div',{class:_vm.actionClass},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }